import { MasonryVerticalLayoutRenderer } from '@leagueplatform/masonry-renderers';

/**
 * Wraps the default verticalLayout renderer with CSS that collapses the
 * container when every child item is empty (i.e. all children returned null).
 *
 * The `:has()` selector checks whether any grandchild StackItem has content.
 * When none do, the outer StackLayout gets `display: none`, which also causes
 * the parent SidebarLayout column to reclaim the space.
 */
export const CollapsibleVerticalLayoutRenderer: typeof MasonryVerticalLayoutRenderer =
  // eslint-disable-next-line react/prop-types
  ({ css, ...props }) => (
    <MasonryVerticalLayoutRenderer
      {...props}
      css={{
        ...css,
        '&:not(:has(> * > :not(:empty)))': {
          display: 'none',
        },
      }}
    />
  );
